import {
  GuestJourneyDetailsCards,
  GuestJourneyDetailsResponse,
} from '../guest-journey-reports.types';

// Titles reference the settings-driven tier names and arrive pre-translated
// from the BE; values arrive pre-formatted.
export const detailsCardsFixture: GuestJourneyDetailsCards = {
  percentExplorers: {
    title: '% Explorers',
    value: '15.0%',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  percentRegulars: {
    title: '% Regulars',
    value: '60.0%',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  percentSuperfans: {
    title: '% Superfans',
    value: '25.0%',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  percentValue: {
    title: '% Value',
    value: '20.0%',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  percentCore: {
    title: '% Core',
    value: '60.0%',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  percentIndulgent: {
    title: '% Indulgent',
    value: '20.0%',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
};

// Stage names + values arrive pre-formatted/resolved from the BE; rendered
// verbatim. Spend tiers highest-first (Indulgent → Value) within each group.
// `segmentKey` is the machine SPEND_TIER_x_VISIT_TIER_y id (spend tier: Value=1,
// Core=2, Indulgent=3) — presumed BE field, drives the per-segment export.
const detailsRows = (
  visitTier: 1 | 2 | 3,
  medians: [string, string, string],
): GuestJourneyDetailsResponse['groups'][number]['rows'] => [
  {
    stage: 'Indulgent',
    segmentKey: `SPEND_TIER_3_VISIT_TIER_${visitTier}`,
    currentTotalMembers: '2,000',
    totalVisits: '1,940',
    totalSpendNetSales: '$75.30',
    averageOrderSize: '$75.30',
    medianDaysBetweenVisits: medians[0],
  },
  {
    stage: 'Core',
    segmentKey: `SPEND_TIER_2_VISIT_TIER_${visitTier}`,
    currentTotalMembers: '1,800',
    totalVisits: '1,710',
    totalSpendNetSales: '$75.30',
    averageOrderSize: '$75.30',
    medianDaysBetweenVisits: medians[1],
  },
  {
    stage: 'Value',
    segmentKey: `SPEND_TIER_1_VISIT_TIER_${visitTier}`,
    currentTotalMembers: '2,200',
    totalVisits: '2,060',
    totalSpendNetSales: '$75.30',
    averageOrderSize: '$75.30',
    medianDaysBetweenVisits: medians[2],
  },
];

// Visit-tier groups in stable display order (highest-frequency first;
// Superfan=3, Regular=2, Explorer=1).
export const detailsFixture: GuestJourneyDetailsResponse = {
  groups: [
    { label: 'Superfan', rows: detailsRows(3, ['10', '5', '2']) },
    { label: 'Regular', rows: detailsRows(2, ['15', '3', '7']) },
    { label: 'Explorer', rows: detailsRows(1, ['20', '25', '30']) },
  ],
};

// Emailed-export envelope for the Details per-segment customer-list export.
export const guestJourneyCustomerExportFixture = {
  status: 'REQUESTED',
  responseMessage: 'Your customer export will be emailed shortly.',
};
